export * from './form-validators/cpf.validator';
export * from './form-validators/must-match.validator';
export * from './form-validators/date.validator';
export * from './form-validators/utils-form.validator';
export * from './form-validators/must-be-different.validator';
export * from './form-validators/dateCard.validator';
export * from './form-validators/is-after-date.validator';
export * from './form-validators/is-before-date.validator';
export * from './validators/email.validator';
